import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showLoginModal: false,
    loginModalType: 'Login',
    shouldGenerateQR: false,
    user: null,
    refreshTrigger: 0
  },
  mutations: {
    setShowLoginModal (state, visible) {
      state.showLoginModal = visible
    },
    setLoginModalType (state, type) {
      state.loginModalType = type
    },
    setShouldGenerateQR (state, shouldGenerate) {
      state.shouldGenerateQR = shouldGenerate
    },
    setUser (state, user) {
      state.user = user
    },
    triggerRefresh (state) {
      state.refreshTrigger++
    }
  },
  actions: {
    showLogin ({ commit }, { type = 'Login', shouldGenerateQR = false } = {}) {
      commit('setLoginModalType', type)
      commit('setShouldGenerateQR', shouldGenerateQR)
      commit('setShowLoginModal', true)
    },
    hideLogin ({ commit }) {
      commit('setShowLoginModal', false)
      commit('setShouldGenerateQR', false)
    },
    updateUser ({ commit }, user) {
      commit('setUser', user)
    },
    triggerRefresh ({ commit }) {
      commit('triggerRefresh')
    }
  },
  modules: {
  }
})
